"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZebecCardProgramFactory = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const constants_1 = require("./constants");
const idl_1 = require("./idl");
/**
 * Zebec Card Program Factory
 */
class ZebecCardProgramFactory {
    /**
     * Create zebec card program instance
     * @param provider
     * @param config
     * @returns
     */
    static getProgram(provider, config) {
        let programId = constants_1.ZEBEC_CARD_PROGRAM.mainnet;
        if (config && config.network === "devnet") {
            programId = constants_1.ZEBEC_CARD_PROGRAM.devnet;
        }
        return new anchor_1.Program(idl_1.IDL, programId, provider);
    }
}
exports.ZebecCardProgramFactory = ZebecCardProgramFactory;
